import { Component, OnInit } from '@angular/core';
// patrones de enrutamiento interno
import { ActivatedRoute, Router } from '@angular/router';
// par ausar formularios contiene formGroup y formcontrol
import { FormControl, FormGroup } from '@angular/forms';
// Modelos
import { OficinaFacturacion } from '../../models/OficinaFacturacion';
// Servicios
import { Location } from '@angular/common';
import { OficinaFacturacionService } from '../../services/oficina-facturacion.service';
import { TranslateService } from '@ngx-translate/core';
import { ModelHelpers } from '../../models/ModelHelpers';
import { GlobalUIUtilsService } from '../../services/global-ui-utils.service';


@Component({
  selector: 'app-oficina-facturacion-edit',
  templateUrl: './oficina-facturacion-edit.component.html',
  styleUrls: ['./oficina-facturacion-edit.component.scss']
})
export class OficinaFacturacionEditComponent implements OnInit {

  //Atributos
  public oficinaFacturacion: OficinaFacturacion;
  public id: number;
  form: FormGroup;
  isNew: boolean;
  title: string;

  isButtonDeleteVisible = false;
  message = this.translate.instant('comunes.toastr_guardado');

  //Constructor
  constructor(private activatedRoute: ActivatedRoute, private oficinaFacturacionService: OficinaFacturacionService, private router: Router,
    private _GlobalUIUtilsService: GlobalUIUtilsService, private translate: TranslateService, private _location: Location) { }

  //Cargar Página
  ngOnInit() {
    this.loadData();
    this.createForm();
  }

  createForm() {
    //Creamos el formulario
    this.form = new FormGroup({
      descripcion: new FormControl(''),
      nombreCompaniaNAV: new FormControl(''),
      oficinaCode: new FormControl(''),
      numSerieFactNAV: new FormControl(''),
      id: new FormControl(''),
      navBaseUrl: new FormControl(''),
      activo: new FormControl(true)
    });
  }

  bindToModel() {
    ModelHelpers.copyFromForm(this.form.value, this.oficinaFacturacion);
  }

  loadData() {
    // retrieve the ID from the 'id' parameter
    this.cargarVariablesUrl();
    if (this.id) {
      this.oficinaFacturacionService.get(this.id).subscribe(result => {
        this.oficinaFacturacion = result;
        this.title = 'Editar';
        this.form.patchValue(this.oficinaFacturacion);
        this.isNew = false;
        this.isButtonDeleteVisible = true;
      }, error => console.error(error));
    } else {
      this.title = 'Crear';
      this.isNew = true;
    }
  }

  //Se encarga de recoger las variables de la URL
  private cargarVariablesUrl() {
    this.id = +this.activatedRoute.snapshot.paramMap.get('id');
  }

  //Funciones
  onSubmit() {
    console.log("Submit");
    if (this.oficinaFacturacion == null) {
      this.oficinaFacturacion = new OficinaFacturacion();
    }
    this.bindToModel();
    // this.oficinaFacturacion.descripcion = this.form.get('descripcion').value;
    // this.oficinaFacturacion.nombreCompaniaNAV = this.form.get('nombreCompaniaNAV').value;
    // this.oficinaFacturacion.oficinaCode = this.form.get('oficinaCode').value;
    // this.oficinaFacturacion.numSerieFactNAV = this.form.get('numSerieFactNAV').value;
    // this.oficinaFacturacion.navBaseUrl = this.form.get('navBaseUrl').value;

    if (this.isNew) {
      console.log("Crear");
      this.oficinaFacturacionService.post(this.oficinaFacturacion).subscribe(result => {
        console.log(`oficinaFacturacion has been updated.`);
        this._location.back();
      }, error => console.log(error));
    } else {
      console.log("Guardar");
      this.oficinaFacturacionService.put(this.oficinaFacturacion).subscribe(result => {
        console.log(`oficinaFacturacion has been updated.`);
        this._GlobalUIUtilsService.success(this.message);
      }, error => console.log(error));
    }
    console.log("Fin Guardar");
  }

  onDelete() {
    console.log("Delete");
    this.oficinaFacturacionService.delete(this.oficinaFacturacion.id).subscribe(result => {
      console.log(`oficinaFacturacion has been updated.`);
      this.router.navigate(['/oficinaFacturacion']);
    }, error => console.log(error));
  }

}
